import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { SITE } from "../config";

const links = [
  { label: "The Book", href: "#book" },
  { label: "Chapters", href: "#chapters" },
  { label: "Author", href: "#author" },
  { label: "Editions", href: "#formats" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 1.6, ease: [0.19, 1, 0.22, 1] }}
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#0a0805]/85 backdrop-blur-xl border-b border-[#d8ab4e]/15" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a href="#top" data-testid="nav-logo" className="font-grotesk font-black tracking-tight text-base sm:text-lg gold-text">
          {SITE.brand}
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="hover-underline text-sm uppercase tracking-[0.2em] text-[#e7dcc2] hover:text-[#f2c968] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href={SITE.amazonUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-buy-btn"
          className="group inline-flex items-center gap-2 bg-[#d8ab4e] text-[#0a0805] px-5 py-2.5 text-xs md:text-sm font-semibold uppercase tracking-widest hover:bg-[#f2c968] transition-colors"
        >
          Buy
          <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
        </a>
      </div>
    </motion.header>
  );
};

export default Nav;
